export default "__VITE_ASSET__eRCUmOsU__"